import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import getApiBaseUrl from './getApiBaseUrl';
import './TossPayment.scss';

const TossSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.appReducer.userInfo);
  const [status, setStatus] = useState('결제 승인 중...');
  const [done, setDone] = useState(false);
  const [payData, setPayData] = useState(null);
  const [planInfo, setPlanInfo] = useState(null);
  const [chargeInfo, setChargeInfo] = useState(null);

  useEffect(() => {
    const paymentKey = searchParams.get('paymentKey');
    const orderId    = searchParams.get('orderId');
    const amount     = searchParams.get('amount');
    const normalizedAmount = Number(amount);
    const userId     = searchParams.get('userId') || userInfo?.userId || '';
    const stCode     = searchParams.get('stCode') || userInfo?.stCode || '';
    const planCode   = searchParams.get('planCode') || '';

    if (!paymentKey || !orderId || !amount || !Number.isFinite(normalizedAmount) || normalizedAmount <= 0) {
      setStatus('유효하지 않은 접근입니다.');
      return;
    }

    const serverUrl = getApiBaseUrl();
    axios.post(`${serverUrl}/toss/confirm`, {
      paymentKey,
      orderId,
      amount: normalizedAmount,
      userId,
      stCode,
      planCode,
    })
      .then(({ data }) => {
        if (data.success) {
          setPayData(data.tossData);
          setPlanInfo(data.planInfo);
          setChargeInfo({
            baseAmount: data.baseAmount || 0,
            bonusAmount: data.bonusAmount || 0
          });
          setStatus('결제가 완료되었습니다.');
          setDone(true);
        } else {
          setStatus(data.message || '결제 승인 실패');
        }
      })
      .catch((e) => {
        const apiMessage = e.response?.data?.message;
        const apiCode = e.response?.data?.code;
        setStatus(apiCode ? `${apiMessage || '결제 승인 실패'} (${apiCode})` : (apiMessage || e.message));
      });
  }, []);

  return (
    <div className="toss-result-wrap">
      <h2 className={done ? 'result-ok' : 'result-pending'}>{status}</h2>
      {payData && (
        <ul className="result-info">
          {planInfo && (
            <li><b>상품명:</b> {planInfo.plan_name}</li>
          )}
          <li><b>결제금액:</b> {Number(payData.totalAmount).toLocaleString()}원</li>
          {chargeInfo && (
            <>
              <li><b>기본 충전:</b> {chargeInfo.baseAmount.toLocaleString()}원</li>
              {chargeInfo.bonusAmount > 0 && (
                <li><b>보너스 충전:</b> {chargeInfo.bonusAmount.toLocaleString()}원 ({planInfo?.bonus_percent}% 추가)</li>
              )}
            </>
          )}
          <li><b>결제수단:</b> {payData.method}</li>
          <li><b>승인시각:</b> {payData.approvedAt ? new Date(payData.approvedAt).toLocaleString('ko-KR', { year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' }) : '-'}</li>
        </ul>
      )}
      <button className="toss-pay-btn" onClick={() => navigate('/')}>
        홈으로 돌아가기
      </button>
    </div>
  );
};

export default TossSuccess;
